import React, { useState, useEffect, useRef } from 'react';
import styled from 'styled-components';
import { RiEdit2Line, RiDeleteBin6Line } from 'react-icons/ri';
import BlogCreateForm from './BlogCreateForm';
import API_URL from '../../config'

const StyledTable = styled.table`
  width: 100%;
  border-collapse: collapse;
  margin: 1rem 0;
`;

const StyledTh = styled.th`
  border: 1px solid #333;
  text-align: left;
  padding: 8px;
`;

const TableBody= styled.tbody`
  /* display: block; */
`;

const StyledTableRow = styled.tr`
  max-height: 300px;
  overflow-y: scroll;
  white-space: nowrap;
`;

const StyledTableHeadRow = styled.tr`
  background-color: #333;
`;

const StyledTd = styled.td`
  border: 1px solid #151515;
  text-align: left;
  padding: 8px;
  max-width: 100px;
  overflow-x: auto;
  /* white-space: nowrap; */
`;

const Button = styled.button`
  background-color: #461199;
  color: #fff;
  border: none;
  padding: 8px 16px;
  cursor: pointer;
  &:hover {
    background-color: #361193;
  }
`;

const DeleteButton = styled.button`
  background-color: #ee5555;
  color: #fff;
  border: none;
  padding: 8px 16px;
  cursor: pointer;
  &:hover {
    background-color: #ee0000;
  }
`;

const EditButton = styled.button`
  background-color: #55c655;
  color: #fff;
  border: none;
  padding: 8px 16px;
  cursor: pointer;
  &:hover {
    background-color: #00a600;
  }
`;

const WarningMsg= styled.h3`
  color: #f77;
`

const BlogTable = ({ blogs, getAllBlogs, onDelete }) => {
  const [editMode, setEditMode] = useState(false);
  const [editedBlog, setEditedBlog] = useState(null);
  const formRef = useRef(null);

  // useEffect(() => {
  //   if (editMode && formRef.current) {
  //     formRef.current.scrollIntoView({ behavior: 'smooth' });
  //   }
  // }, [editMode]);

  const deleteBlog = async (id) => {
    try {
      const response = await fetch(`${API_URL}/delete-blog/${id}`, {
        method: 'DELETE',
      });
      if (!response.ok) {
        throw new Error('Failed to delete blog');
      }
      getAllBlogs();
    } catch (error) {
      console.error('Error deleting blog:', error);
    }
  };

  const handleEdit = (blog) => {
    setEditedBlog(blog);
    setEditMode(true);
  };

  const handleSaveEdit = async () => {
    try {
      if (!editedBlog) {
        throw new Error('No blog to update');
      }

      if (!editedBlog.id) {
        throw new Error('Edited blog must have a valid ID');
      }

      const response = await fetch(`${API_URL}/update-blog/${editedBlog.id}`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(editedBlog),
      });

      if (!response.ok) {
        const errorText = await response.text();
        throw new Error(`Failed to update blog: ${response.status} - ${errorText}`);
      }

      // Update the blogs state with the edited blog
      setEditedBlog(prevBlogs => prevBlogs.map(blogItem => {
        if (blogItem.id === editedBlog.id) {
          return editedBlog;
        }
        return blogItem;
      }));

      setEditMode(false);
      setEditedBlog(null);
    } catch (error) {
      console.error('Error updating blog:', error);
    }
  };

  const handleCancelEdit = () => {
    setEditMode(false);
    setEditedBlog(null);
  };

  const handleEditChange = (event) => {
    const { name, value } = event.target;
    if (editedBlog !== null) { // Ensure editedBlog is not null
        setEditedBlog(prevState => ({
            ...prevState,
            [name]: name === 'views' ? parseInt(value, 10) : value
        }));
    }
};

  return (
    <>
      {editMode && (
        <BlogCreateForm
          // ref={formRef}
          getAllBlogs={getAllBlogs}
          setEditMode={setEditMode}
          blog={editedBlog}
          onSave={handleSaveEdit}
          onCancel={handleCancelEdit}
          onChange={handleEditChange}
        />
      )}
      <WarningMsg>Beware you can delete a blog without confirmation!</WarningMsg>
      <StyledTable>
        <thead>
          <StyledTableHeadRow>
            <StyledTh>ID</StyledTh>
            <StyledTh>Image</StyledTh>
            <StyledTh>Title</StyledTh>
            <StyledTh>Content</StyledTh>
            <StyledTh>Views</StyledTh>
            <StyledTh>Actions</StyledTh>
          </StyledTableHeadRow>
        </thead>
        <TableBody>
          {blogs.map(blog => (
            <StyledTableRow key={blog.id}>
              <StyledTd>{blog.id}</StyledTd>
              <StyledTd><img src={blog.image} alt="Blog" width="100" height="100" /></StyledTd>
              <StyledTd>{blog.title}</StyledTd>
              <StyledTd>{blog.content}</StyledTd>
              <StyledTd>{blog.views}</StyledTd>
              <StyledTd>
                <EditButton onClick={() => handleEdit(blog)}><RiEdit2Line /> Edit</EditButton>
                <DeleteButton onClick={() => deleteBlog(blog.id)}><RiDeleteBin6Line /> Delete</DeleteButton>
              </StyledTd>
            </StyledTableRow>
          ))}
        </TableBody>
      </StyledTable>
    </>
  );
};

export default BlogTable;
